export const FACILITY_DETAILS_STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  OK: 3,
  FAILED: 4,
  EXTERNAL_CHANGE: 5
};

export const FACILITIES_FILTER_SEARCH_TYPES = {
  FACILITIES: "facilities",
  CITY: "city",
  FACILITIES_GROUPS: "facilitiesGroups"
};

export const FACILITIES_FILTER_SEARCH_TYPES_API = {
  FACILITIES_IDS: "facilities_ids",
  CITIES: "cities",
  FACILITIES_GROUPS: "facilities_groups"
};
